import BaseAPI from "../base";
import moment from "moment";
import { generateRandomString } from "@/utils/utils";
const CryptoJS = require("crypto-js");
class ReportsService extends BaseAPI {
  getChannelListApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/account/channel/list`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  getUserListApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/user/list`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  getWXListApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/customer/list`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  getChannelListItemApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/customer/channel/performance`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  exportExcel(params) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/customer/list/export`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...params,
      },
      responseType: "blob",
    });
  }
  getChannelLabelListApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/customer/channel/labels/list`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  getDingUserListApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/customers`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  exportChannelExcel(params) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'crm-report' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_CRM_APIBASEURL}/report/customer/channel/labels/export`,
      headers: {
        username: 'crm-report',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...params,
      },
      responseType: "blob",
    });
  }
}

export default new ReportsService();
